<!----------------------- Модальне вікно вибору компаній --------------------->
<template>
  <smallModal v-if="show === true" @escape="close">
    <companyList :data="data" @goToCompany="goToCompany" @logout="logout"></companyList>
  </smallModal>
</template>
<script>
import companyList from "@/components/choiceCompany/companyList.vue" // Компонент списку компаній для вход
import smallModal from '@/components/modals/smallModal.vue'; // Компонент маленького модального вікна
import Cookies from 'js-cookie'; // Модуль для роботи з кукі
import { store } from "@/store.js"; // Глобальне сховище даних
import { cabinetAPi } from '@/API.js';
const apiList = new cabinetAPi();
let apiCookies = Cookies;
if (process.env.NODE_ENV == 'production') {
  apiCookies = Cookies.withAttributes({ domain: ".skyservice.online" })
}

export default {
  data() {
    return {
      show: false,
      data: ""
    }
  },
  created() {
    this.setLocation()
    // Отримуємо токен з cookies
    let token = Cookies.get("token");
    // Якщо токен існує, отримуємо компанії
    if (token) {
      this.getCompanies();
    }
  },
  components: {
    companyList,
    smallModal,
  },
  computed: {
    // Мова додатку
    lang() {
      /*if (this.form.lang != '' && this.form.lang != null) {
        window.lang = store.langs[this.form.lang]()
      }*/
      return window.lang;
    },
    phrasesArray() {
      return [
        this.lang['preparingCompany1'],
        this.lang['preparingCompany2'],
        this.lang['preparingCompany3'],
        this.lang['preparingCompany4']
      ]
    },
  },
  methods: {
    setLocation() {
      // Оскільки тут ми вже авторизовані, то запам'ятовуємо що ми хочемо редиректиться сюди
      let currentLocation = {
        project: "auth.skyservice.online"
      };

      apiCookies.set("location", JSON.stringify(currentLocation), { expires: 180 })

      try {
        let iosData = {
          location: currentLocation
        }
        window.webkit.messageHandlers.saveUserData.postMessage(JSON.stringify(iosData));
      }
      catch (err) {
        // Не додаток ios
      }
    },
    getCompanies() { // Отримуємо дані о персоні
      try {
        apiList.getCompanies().then(resp => {

          if (resp.data.status == 'done') {
            if (resp.data) { // Після отримання даних про компанію передаємо їх у чат

              // store.lang = resp.data.data.lang;
              console.log('resp.data.data.lang =',resp.data.data.lang)
                            console.log('store.lang =',store.lang)

              // Якщо компанія одна і вона НЕ заблокована, то автоматично заходим в неї
              if (resp.data.data.companies.length == 1 && !resp.data.data.companies[0]?.blocked) {
                console.log(resp.data.data.companies[0]?.blocked);
                store.loader = true;
                this.goToCompany(resp.data.data.companies[0])
              }  // Якщо 0 компаній або 5 і більше компаній або є запрошення то автоматично перекидує в кабінет
              else if (resp.data.data.companies.length <= 0 ||
                resp.data.data.companies.length > 5 ||
                resp.data.data.invitations.length >= 1 ||
                // Якщо одна компанія і вона заблокована то автоматично перекидує в кабінет
                (resp.data.data?.companies.length === 1 && resp.data.data?.companies[0]?.blocked)) {
                console.log("Довжина " + resp.data.data.companies.length);
                console.log("Заблокованно" + resp.data.data?.companies[0]?.blocked);
                console.log("Перекидуємо в кабінет");
                store.loader = true;
                document.location.href = "https://cabinet.skyservice.online";
              } // Якщо більше 1-ї компанії то показуємо список
              else if (resp.data.data.companies.length > 1) {
                this.data = resp.data.data;
                this.show = true;
              }
            }

          } else if (resp.data.error == "Lost connection to Redis server." ||
            resp.data.error == "socket error on read socket") {
            if (document.referrer) {
              let status = confirm("Authorization temporary is unavailable. Go back to: " + document.referrer);
              if (status) {
                document.location.href = document.referrer;
              } else {
                this.gotoAuth();
              }
            } else {
              // У разі помилки кикаємо токен, якщо він є і редиректим на сторінку логіна
              this.gotoAuth();
            }
            // Якщо впав редис то не редиректим на авторизацію
          } else {
            // У разі помилки кикаємо токен, якщо він є і редиректим на сторінку логіна
            this.gotoAuth();
          }
        }).catch(err => {
          console.error(err)
          window.say.messageError(err);
        })
      } catch (err) {
        window.say.messageError(this.lang['Error']);
      }
    },
    gotoAuth() {
      // Видаляємо токен
      if (Cookies.get("token")) {
        apiCookies.set("token", '', { expires: -1 });
        //store.token = null;
      }
      document.location.href = 'https://auth.skyservice.online/';
    },
    startPrepareCompany(status) {
      if (status === 'end') {
        store.loaderText = '';
        store.loader = false;
        store.isBackground = false;
        return;
      } else {
        const outputPhrases = (index) => {
          let delay = index === 0 ? 2000 : 3000;
          if (index < this.phrasesArray.length) {
            store.loader = false;
            setTimeout(() => {
              store.loader = true;
              store.loaderText = this.phrasesArray[index];
              setTimeout(() => {
                outputPhrases(index + 1);
                console.log("delay", delay)
                console.log('index', index)
              }, delay);
            }, 0);
          }
        };
        outputPhrases(0);
      }
    },
    goToCompany(e) {
      if (e.blocked) {
        window.say.messageError(this.lang['companyBlocked'])
        console.log("Компанія заблокована");
      }
      else if (this.sortList) {
        console.log("У режимі сортування вхід до компанії не дозволяється")
      } else {
        try {
          store.isBackground = true; 
          if (e.is_new) {
            console.warn(e)
            this.show = false;
            this.startPrepareCompany('start')
          }
          apiList.redirectPerson({ token: Cookies.get("token"), company_id: e.company_id }).then(resp => {
            store.loader = true;
            console.log(resp)
            if (e.is_new) {
              console.warn(e)
              this.startPrepareCompany('end');
            }
            if (resp.data.status == 'done') {
              // Костыльчик для старого сервиса
              // Скорей всего это решение идеально для интеграции - 
              // со сторонними сервисами и более предпочтительное чем то что было до этого
              // Поскольку мы хотим знать где был последний раз клиент 
              // и при следующем входе его туда обратно перебрасывать
              // то нам нужно запомнить в куки location
              // но сделать это так как мы сделали в новой админке не получится так как с 
              // online.skyservice.pro у нас нету доступа к кукам .skyservice.online
              // по этому запоминаем куда мы перешли здесь в случае если это старый сервер
              if (e.company_server == "s-1") {
                let currentLocation = {
                  project: "online.skyservice.pro"
                };

                apiCookies.set("location", JSON.stringify(currentLocation), { expires: 180 })

                try {
                  let iosData = {
                    location: currentLocation
                  }
                  window.webkit.messageHandlers.saveUserData.postMessage(JSON.stringify(iosData));
                } catch (err) {
                  // Не додаток ios
                }
              }

              if (e.company_server == "s-5") {
                let currentLocation = {
                  project: "online2.skyservice.pro"
                };

                apiCookies.set("location", JSON.stringify(currentLocation), { expires: 180 })

                try {
                  let iosData = {
                    location: currentLocation
                  }
                  window.webkit.messageHandlers.saveUserData.postMessage(JSON.stringify(iosData));
                } catch (err) {
                  // Не додаток ios
                }
              }
              location.href = resp.data.data;
            }
            else if (resp.data.error == 'worker is inactive') {
              window.say.messageError(this.lang['youBlockedInComp']);
            }
            else {
              this.getData();
              window.say.messageError(this.lang['Error']);
            }
          })
        } catch (err) {
          window.say.messageError(this.lang['Error']);
        }
      }
    },
    logout() {
      try {
        // При виході кікаємо токен, закриваємо модалку, та й викидаємо на сторінку логіна
        apiList.logout({ token: Cookies.get("token") }).then(resp => {
          if (resp.data.status == 'done') {
            apiCookies.set("token", '', { expires: -1 });
            return
          } else {
            window.say.messageError(this.lang['Error']);
          }
        }).then(() => {
          // this.$emit('logout');
          // this.$router.push('/');
          location.reload(true);
          //document.location.href = 'https://auth.skyservice.online/';
        });
      } catch (err) {
        console.log(err)
      }
    },
    close() {
      this.show = false
    }
  }
}
</script>